import React, { useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';
import AppContext from './context';
import usePersistedStateObject from '../hooks/usePersistedStateObject';
import StorageKeys from '../constants/storageKeys';

const App = () => {

  const [auth, setAuth] = usePersistedStateObject(StorageKeys.AUTH);

  const value = useMemo(() => ({
    auth,
    setAuth
  }), [auth])

  return (
    <AppContext.Provider value={value}>
      <BrowserRouter>
        <Routes/>
      </BrowserRouter>
    </AppContext.Provider>
  );
};

export default App;
